/**
 * Parse a time string into a chronology timestamp for sorting.
 * Handles various date formats, with special support for year-only strings.
 * @param time - date/time string or undefined
 * @returns milliseconds since epoch (number) or 0 for invalid/missing input
 */
export function parseToChronology(time: string | undefined) {
  if (!time) {
    return 0
  }

  const trimmedTime = String(time).trim()

  const yearMatch = trimmedTime.match(/^(\d{4})$/)
  if (yearMatch) {
    return new Date(Number(yearMatch[1]), 0, 1).getTime()
  }

  const parsedTime = Date.parse(trimmedTime)

  if (parsedTime) {
    return parsedTime
  }
  else {
    return 0
  }
}
